import React, { useContext } from 'react';
import { BASE_URL } from '../../../../BaseUrl';
import { currencySymbolLeft, getSystemSettings } from '../../../../functions/Functions';
import { SettingsContext } from '../../../../contexts/Settings';
import { FaPlus, FaMinus, FaTrash, FaCheck } from 'react-icons/fa';

const PopularItemCard = ({ item, onClick, isOrderPunchingEnabled, isSidebar = false, cartItem, onRemoveFromCart, showImage = true }) => {
  const { generalSettings } = useContext(SettingsContext);

  const handleDisable = (foodItem) => {
    const isDisabled = !!((generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) &&
      foodItem?.is_deal === 0 && !foodItem?.is_recipe));
    return isDisabled;
  };

  const Isshowtags = (foodItem) => {
    return (
      generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      foodItem?.is_deal === 0 &&
      !foodItem?.is_recipe
    );
  };

  const renderStockQty = (foodItem) => {
    if (!foodItem) return null;

    if (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) {
      return (
        <span className="modern-tag out-of-stock">Out of stock</span>
      );
    } 
  };

  const disabled = handleDisable(item);

  // The image-hidden class switches this card to a compact text-only layout.
  return (
    <div 
      className={`popular-item-card flex-shrink-0 ${disabled ? "disabled" : ""} ${isSidebar ? "sidebar-card" : "main-card"} ${showImage ? "" : "image-hidden"}`}
      onClick={() => { if (!disabled) onClick(item); }}
    >
      {showImage && <img
        src={item.image ? BASE_URL + item.image : "/assets/img/default-item.jpeg"} 
        alt={item.name}
        className="popular-item-img"
        loading="lazy"
        onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
      />}
      
      <div className="popular-item-overlay"></div>

      {cartItem && cartItem.quantity > 0 && (
        <div className="position-absolute" style={{ top: '6px', left: '6px', zIndex: 10 }}>
          <span className="badge bg-white text-dark shadow-sm d-flex align-items-center px-2 py-1 rounded-pill item-in-cart-badge">
             <FaCheck className="text-success mr-1 item-in-cart-icon" /> {cartItem.quantity} in cart
          </span>
        </div>
      )}

      {Isshowtags(item) && (
        <div className="modern-tag-overlay">
          {renderStockQty(item)}
        </div>
      )}

      <div className={`popular-item-content ${showImage ? "" : "image-hidden-content"}`}>
        <h6 className="mb-0 text-white fw-bold popular-item-title">{item.name}</h6>
        {item.price && (
          <div className="popular-item-price fw-semibold mt-1">
            {currencySymbolLeft()} {item.price}
          </div>
        )}
      </div>

      {isOrderPunchingEnabled && !disabled && (
        <div className="popular-action-container position-absolute">
          {!cartItem ? (
            <button 
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm popular-add-btn"
              onClick={(e) => { e.stopPropagation(); onClick(item); }}
            >
              <FaPlus size={12} />
            </button>
          ) : (
            <div className="d-flex align-items-center justify-content-between rounded-pill shadow-sm popular-add-filled">
              <button className="btn border-0 text-white d-flex align-items-center justify-content-center p-0 action-btn-sm" onClick={(e) => { e.stopPropagation(); onRemoveFromCart(item); }}>
                {cartItem.quantity === 1 ? <FaTrash size={10} /> : <FaMinus size={10} />}
              </button>
              <span className="font-weight-bold text-white popular-cart-quantity-text">
                {cartItem.quantity}
              </span>
              <button className="btn border-0 text-white d-flex align-items-center justify-content-center p-0 action-btn-sm" onClick={(e) => { e.stopPropagation(); onClick(item); }}>
                <FaPlus size={10} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PopularItemCard;
